
  // Export
  module.exports =
  {

    // Call offs scripts
    callOffs:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#phases'), APPLICATION._PATH_PREFIX + 'development/call-offs-result', 'Development', 'callOffsResult')        
      }

    },

    // Call offs result scripts
    callOffsResult:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#phases', 'Development', 'callOffsResult')

        // Get the development
        var development = $('#development_id')

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'dropdown')
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    }

  }